module.exports = __webpack_public_path__ + "images/landing/video-previews/Animatron_Explainer_Video_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Animatron_Explainer_Video_2x.jpg
// module id = m8uy
// module chunks = 1